var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelTumblr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 64,
  viewBox: "0 0 38 64",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 15.503C7.416 15.001 14.115 13.253 13.626.2L20.727 0l-.384 15.304H38V27.43l-17.657-.2.192 18.088C22.554 57.25 33.807 53.113 38 48.894v10.137c-3.259 2.68-9.706 4.698-14.97 4.969-9.053-1.008-16.818-4.057-17.272-18.683V27.429H0z"
})));
export default SvgChannelTumblr;